export function Changelog7() {
  return (
    <div>
      <div style={{ fontSize: 16, fontWeight: "bold" }}>Bug Fixes</div>
      <div>
        - Fixed bug where auto buyers where working even if not purchased
      </div>
      <div>- Fixed producer strengthening showing infinity</div>
      <div>- Fixed producer timers taking longer when not focused</div>
      <div style={{ fontSize: 16, fontWeight: "bold" }}>Changes</div>
      <div>- Open reddit-link in new tab</div>
      <div>- Add changelog to the game</div>
      <div>- Show max particles in molecule creation button</div>
    </div>
  );
}
